import { render, staticRenderFns } from "./assetAdd.vue?vue&type=template&id=3b1c74a6&scoped=true"
import script from "./assetAdd.vue?vue&type=script&lang=js"
export * from "./assetAdd.vue?vue&type=script&lang=js"
import style0 from "./assetAdd.vue?vue&type=style&index=0&id=3b1c74a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1c74a6",
  null
  
)

export default component.exports